import { J1TransferarrowB, J2Multiply, J2Validate } from '@e3dc-react/icons'
import { Tooltip } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { SystemStatusType } from './SystemSettingsUtils'

interface StyleProps {
  status: SystemStatusType
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  container: {
    display: 'flex',
    position: 'absolute',
    top: theme.spacing(1),
    right: 0,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 60,
    width: '30px',
    height: '30px',
    backgroundColor:
      props.status === 'running'
        ? theme.palette.primary.dark
        : props.status === 'service'
        ? theme.palette.blue?.main
        : props.status === 'between'
        ? '#EBDA2F'
        : '#E6564C',
  },
  span: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    color: '#fff',
    fontSize: '32px',
  },
}))

interface SystemStatusIndicatorProps {
  status: SystemStatusType
}

const SystemStatusIndicator: React.FC<SystemStatusIndicatorProps> = ({ status }) => {
  const { classes } = useStyles({ status })

  return (
    <div className={classes.container}>
      <Tooltip title={`status: ${status}`} enterTouchDelay={0} placement="top">
        <span className={classes.span}>
          {status === 'running' || status === 'service' ? (
            <J2Validate className={classes.icon} />
          ) : status === 'between' ? (
            <J1TransferarrowB className={classes.icon} />
          ) : (
            <J2Multiply className={classes.icon} />
          )}
        </span>
      </Tooltip>
    </div>
  )
}

export default SystemStatusIndicator
